import { getCanViewLuxPlusBenefits, getIsLuxPlusLPPEnabled } from 'luxPlus/selectors/featureToggle'
import { useAppSelector } from 'hooks/reduxHooks'

export default function useBedbankDiscount(discount = 0, memberDiscount = 0): number {
  const canViewLuxPlusBenefits = useAppSelector(getCanViewLuxPlusBenefits)
  const luxPlusLPPEnabled = useAppSelector(getIsLuxPlusLPPEnabled)

  if ((memberDiscount ?? 0) > 0 && canViewLuxPlusBenefits && luxPlusLPPEnabled) {
    return memberDiscount
  }

  return discount
}
